var map = {
	"./assets/turn.png": "879a",
	"./base/Abnormal.png": "2882",
	"./base/Attack.png": "0884",
	"./base/BlendBuff.png": "44c7",
	"./base/Buff.png": "5261",
	"./base/Debuff.png": "9b49",
	"./base/Earth.png": "efef",
	"./base/Fire.png": "0086",
	"./base/Heal.png": "7a78",
	"./base/Moon.png": "0c4c",
	"./base/Other.png": "2862",
	"./base/Other2.png": "6212",
	"./base/Sun.png": "d5c5",
	"./base/Water.png": "5066",
	"./base/Wind.png": "74c2",
	"./en/0.md": "82b1",
	"./en/1.md": "b2b8",
	"./en/10.md": "0aea",
	"./en/11.md": "4f2e",
	"./en/12.md": "698d",
	"./en/13.md": "8971",
	"./en/14.md": "7f3e",
	"./en/15.md": "c66b",
	"./en/16.md": "8dba",
	"./en/17.md": "ab93",
	"./en/18.md": "bac0",
	"./en/19.md": "fc60",
	"./en/2.md": "15c9",
	"./en/20.md": "b1c8",
	"./en/21.md": "2dec",
	"./en/22.md": "537d",
	"./en/23.md": "c352",
	"./en/24.md": "6034",
	"./en/25.md": "79cc",
	"./en/26.md": "c2bb",
	"./en/3.md": "7e11",
	"./en/4.md": "0ddb",
	"./en/5.md": "d2a9",
	"./en/6.md": "e50e",
	"./en/7.md": "714a",
	"./en/8.md": "9d20",
	"./en/9.md": "6e66",
	"./en/appendix0.md": "5039",
	"./en/appendix1.md": "eb96",
	"./en/appendix2.md": "b950",
	"./en/appendix3.md": "3a5f",
	"./icon/AbnormalDisable.png": "7fb9",
	"./icon/AbnormalProbabilityDown.png": "b0c6",
	"./icon/AbnormalProbabilityUp.png": "d58d",
	"./icon/AbsorbAttack.png": "5d07",
	"./icon/Atk.png": "ab90",
	"./icon/AtkCard.png": "fa11",
	"./icon/Barrier.png": "d9a5",
	"./icon/Bearish.png": "9db4",
	"./icon/ChainCoef.png": "b6e2",
	"./icon/Clear.png": "4146",
	"./icon/Confusion.png": "faee",
	"./icon/CriticalDamage.png": "65ae",
	"./icon/Def.png": "76a2",
	"./icon/Earth.png": "47d5",
	"./icon/Fire.png": "b796",
	"./icon/Forbidden.png": "2dfc",
	"./icon/Hate.png": "27a3",
	"./icon/Heal.png": "160b",
	"./icon/HealCard.png": "411c",
	"./icon/Isolation.png": "14ff",
	"./icon/LoadFactorReduce.png": "43e6",
	"./icon/Luck.png": "e120",
	"./icon/MDef.png": "ffe8",
	"./icon/Mgc.png": "c358",
	"./icon/MgcCard.png": "6cff",
	"./icon/Moon.png": "2858",
	"./icon/NextAtk.png": "edcf",
	"./icon/NextLuck.png": "5111",
	"./icon/NextMgc.png": "2b8e",
	"./icon/Other.png": "6b7f",
	"./icon/OtherCard.png": "7d4d",
	"./icon/Paralysis.png": "2777",
	"./icon/Poison.png": "ca49",
	"./icon/Recast.png": "5b61",
	"./icon/Regene.png": "22f8",
	"./icon/Silence.png": "78d1",
	"./icon/Sleep.png": "64d0",
	"./icon/Spd.png": "cc5b",
	"./icon/Sun.png": "ab420",
	"./icon/Unhappy.png": "adc1",
	"./icon/Water.png": "dfe9",
	"./icon/WeakElementBonus.png": "8ce3",
	"./icon/Wind.png": "e8f1",
	"./ja/0.md": "de7c",
	"./ja/1.md": "3ea8",
	"./ja/10.md": "7449",
	"./ja/11.md": "6921",
	"./ja/12.md": "f836",
	"./ja/13.md": "4713",
	"./ja/14.md": "a975",
	"./ja/15.md": "00cb",
	"./ja/16.md": "f39d",
	"./ja/17.md": "6022",
	"./ja/18.md": "a9ee",
	"./ja/19.md": "1fff",
	"./ja/2.md": "c707",
	"./ja/20.md": "cb8e",
	"./ja/21.md": "bfbf",
	"./ja/22.md": "943b",
	"./ja/23.md": "4307",
	"./ja/24.md": "af23",
	"./ja/25.md": "914a",
	"./ja/26.md": "460c",
	"./ja/3.md": "b593",
	"./ja/4.md": "3d8c",
	"./ja/5.md": "796c",
	"./ja/6.md": "6249",
	"./ja/7.md": "7aa3",
	"./ja/8.md": "def4",
	"./ja/9.md": "f512",
	"./ja/appendix0.md": "6e12",
	"./ja/appendix1.md": "7d05",
	"./ja/appendix2.md": "5b1d",
	"./ja/appendix3.md": "98c0",
	"./merge/Abnormal-AbnormalDisable.png": "e50c",
	"./merge/Abnormal-AbnormalProbabilityDown.png": "304c",
	"./merge/Abnormal-AbnormalProbabilityUp.png": "b8d0",
	"./merge/Abnormal-AbsorbAttack.png": "55c0",
	"./merge/Abnormal-Atk.png": "94d3",
	"./merge/Abnormal-AtkCard.png": "1d07",
	"./merge/Abnormal-Barrier.png": "157a",
	"./merge/Abnormal-Bearish.png": "f61d",
	"./merge/Abnormal-ChainCoef.png": "c5d8",
	"./merge/Abnormal-Clear.png": "6045",
	"./merge/Abnormal-Confusion.png": "c3bd",
	"./merge/Abnormal-CriticalDamage.png": "85c6",
	"./merge/Abnormal-Def.png": "3957",
	"./merge/Abnormal-Earth.png": "4068",
	"./merge/Abnormal-Fire.png": "e6a0",
	"./merge/Abnormal-Forbidden.png": "f233",
	"./merge/Abnormal-Hate.png": "41fb",
	"./merge/Abnormal-Heal.png": "433b",
	"./merge/Abnormal-HealCard.png": "121e",
	"./merge/Abnormal-Isolation.png": "d633",
	"./merge/Abnormal-LoadFactorReduce.png": "13bc",
	"./merge/Abnormal-Luck.png": "af2b",
	"./merge/Abnormal-MDef.png": "34ba",
	"./merge/Abnormal-Mgc.png": "16eb",
	"./merge/Abnormal-MgcCard.png": "10ae",
	"./merge/Abnormal-Moon.png": "92c8",
	"./merge/Abnormal-NextAtk.png": "6186",
	"./merge/Abnormal-NextLuck.png": "93e2",
	"./merge/Abnormal-NextMgc.png": "a6f3",
	"./merge/Abnormal-Other.png": "66e8",
	"./merge/Abnormal-OtherCard.png": "efc1",
	"./merge/Abnormal-Paralysis.png": "ab42",
	"./merge/Abnormal-Poison.png": "e609",
	"./merge/Abnormal-Recast.png": "89c5",
	"./merge/Abnormal-Regene.png": "6d79",
	"./merge/Abnormal-Silence.png": "feba",
	"./merge/Abnormal-Sleep.png": "9e6a",
	"./merge/Abnormal-Spd.png": "2bec",
	"./merge/Abnormal-Sun.png": "49e8",
	"./merge/Abnormal-Unhappy.png": "92ac",
	"./merge/Abnormal-Water.png": "2cba",
	"./merge/Abnormal-WeakElementBonus.png": "f1a3",
	"./merge/Abnormal-Wind.png": "c71c",
	"./merge/Abnormal.png": "8d01",
	"./merge/Attack-AbnormalDisable.png": "e1e3",
	"./merge/Attack-AbnormalProbabilityDown.png": "a46e",
	"./merge/Attack-AbnormalProbabilityUp.png": "aefb",
	"./merge/Attack-AbsorbAttack.png": "d44e",
	"./merge/Attack-Atk.png": "827c",
	"./merge/Attack-AtkCard.png": "e3be",
	"./merge/Attack-Barrier.png": "feeb",
	"./merge/Attack-Bearish.png": "a60e",
	"./merge/Attack-ChainCoef.png": "9dd6",
	"./merge/Attack-Clear.png": "0c29",
	"./merge/Attack-Confusion.png": "a718",
	"./merge/Attack-CriticalDamage.png": "1e50",
	"./merge/Attack-Def.png": "acf1",
	"./merge/Attack-Earth.png": "f83f",
	"./merge/Attack-Fire.png": "1879",
	"./merge/Attack-Forbidden.png": "ff8d",
	"./merge/Attack-Hate.png": "450b",
	"./merge/Attack-Heal.png": "cdbc",
	"./merge/Attack-HealCard.png": "3749",
	"./merge/Attack-Isolation.png": "40e4",
	"./merge/Attack-LoadFactorReduce.png": "234b",
	"./merge/Attack-Luck.png": "3ab3",
	"./merge/Attack-MDef.png": "33bd",
	"./merge/Attack-Mgc.png": "9bbe",
	"./merge/Attack-MgcCard.png": "2e94",
	"./merge/Attack-Moon.png": "d6c9",
	"./merge/Attack-NextAtk.png": "3bbf",
	"./merge/Attack-NextLuck.png": "87fb",
	"./merge/Attack-NextMgc.png": "6927",
	"./merge/Attack-Other.png": "c806",
	"./merge/Attack-OtherCard.png": "95c1",
	"./merge/Attack-Paralysis.png": "4a67",
	"./merge/Attack-Poison.png": "38a9",
	"./merge/Attack-Recast.png": "875e",
	"./merge/Attack-Regene.png": "420c",
	"./merge/Attack-Silence.png": "d6ab",
	"./merge/Attack-Sleep.png": "f838",
	"./merge/Attack-Spd.png": "8c5d",
	"./merge/Attack-Sun.png": "8285",
	"./merge/Attack-Unhappy.png": "2f27",
	"./merge/Attack-Water.png": "3f96",
	"./merge/Attack-WeakElementBonus.png": "c4ff",
	"./merge/Attack-Wind.png": "34b7",
	"./merge/Attack.png": "63ca",
	"./merge/BlendBuff-AbnormalDisable.png": "3bca",
	"./merge/BlendBuff-AbnormalProbabilityDown.png": "18ba",
	"./merge/BlendBuff-AbnormalProbabilityUp.png": "c758",
	"./merge/BlendBuff-AbsorbAttack.png": "2245",
	"./merge/BlendBuff-Atk.png": "d504",
	"./merge/BlendBuff-AtkCard.png": "a189",
	"./merge/BlendBuff-Barrier.png": "9f81",
	"./merge/BlendBuff-Bearish.png": "e87d",
	"./merge/BlendBuff-ChainCoef.png": "91bd",
	"./merge/BlendBuff-Clear.png": "1544",
	"./merge/BlendBuff-Confusion.png": "ca83",
	"./merge/BlendBuff-CriticalDamage.png": "3a8d",
	"./merge/BlendBuff-Def.png": "1266",
	"./merge/BlendBuff-Earth.png": "1e75",
	"./merge/BlendBuff-Fire.png": "2e7e",
	"./merge/BlendBuff-Forbidden.png": "5896",
	"./merge/BlendBuff-Hate.png": "4700",
	"./merge/BlendBuff-Heal.png": "22ee",
	"./merge/BlendBuff-HealCard.png": "0a98",
	"./merge/BlendBuff-Isolation.png": "4c6f",
	"./merge/BlendBuff-LoadFactorReduce.png": "c615",
	"./merge/BlendBuff-Luck.png": "1d58",
	"./merge/BlendBuff-MDef.png": "93dc",
	"./merge/BlendBuff-Mgc.png": "c278",
	"./merge/BlendBuff-MgcCard.png": "2267",
	"./merge/BlendBuff-Moon.png": "eb48",
	"./merge/BlendBuff-NextAtk.png": "9554",
	"./merge/BlendBuff-NextLuck.png": "2a43",
	"./merge/BlendBuff-NextMgc.png": "11c9",
	"./merge/BlendBuff-Other.png": "abe8",
	"./merge/BlendBuff-OtherCard.png": "1325",
	"./merge/BlendBuff-Paralysis.png": "072c",
	"./merge/BlendBuff-Poison.png": "6c8a",
	"./merge/BlendBuff-Recast.png": "0beb",
	"./merge/BlendBuff-Regene.png": "c45c",
	"./merge/BlendBuff-Silence.png": "628d",
	"./merge/BlendBuff-Sleep.png": "bdb3",
	"./merge/BlendBuff-Spd.png": "e173",
	"./merge/BlendBuff-Sun.png": "3d75",
	"./merge/BlendBuff-Unhappy.png": "8b22",
	"./merge/BlendBuff-Water.png": "9012",
	"./merge/BlendBuff-WeakElementBonus.png": "bb90",
	"./merge/BlendBuff-Wind.png": "5b19",
	"./merge/BlendBuff.png": "7fba",
	"./merge/Buff-AbnormalDisable.png": "4c0a",
	"./merge/Buff-AbnormalProbabilityDown.png": "57cb",
	"./merge/Buff-AbnormalProbabilityUp.png": "f5b1",
	"./merge/Buff-AbsorbAttack.png": "8324",
	"./merge/Buff-Atk.png": "f2d0",
	"./merge/Buff-AtkCard.png": "5447",
	"./merge/Buff-Barrier.png": "9eba",
	"./merge/Buff-Bearish.png": "ea11",
	"./merge/Buff-ChainCoef.png": "81df",
	"./merge/Buff-Clear.png": "4868",
	"./merge/Buff-Confusion.png": "0998",
	"./merge/Buff-CriticalDamage.png": "6836",
	"./merge/Buff-Def.png": "9660",
	"./merge/Buff-Earth.png": "9b5b",
	"./merge/Buff-Fire.png": "e986",
	"./merge/Buff-Forbidden.png": "3ad9",
	"./merge/Buff-Hate.png": "1eb4",
	"./merge/Buff-Heal.png": "6b6e",
	"./merge/Buff-HealCard.png": "df30",
	"./merge/Buff-Isolation.png": "4a50",
	"./merge/Buff-LoadFactorReduce.png": "595d",
	"./merge/Buff-Luck.png": "ebc2",
	"./merge/Buff-MDef.png": "61f0",
	"./merge/Buff-Mgc.png": "6845",
	"./merge/Buff-MgcCard.png": "8fc0",
	"./merge/Buff-Moon.png": "1b24",
	"./merge/Buff-NextAtk.png": "7c60",
	"./merge/Buff-NextLuck.png": "ef22",
	"./merge/Buff-NextMgc.png": "236b",
	"./merge/Buff-Other.png": "25ca",
	"./merge/Buff-OtherCard.png": "6658",
	"./merge/Buff-Paralysis.png": "6fff",
	"./merge/Buff-Poison.png": "be88",
	"./merge/Buff-Recast.png": "8311",
	"./merge/Buff-Regene.png": "c49b",
	"./merge/Buff-Silence.png": "f463",
	"./merge/Buff-Sleep.png": "ee63",
	"./merge/Buff-Spd.png": "bcf4",
	"./merge/Buff-Sun.png": "d39d",
	"./merge/Buff-Unhappy.png": "dbe3",
	"./merge/Buff-Water.png": "da18",
	"./merge/Buff-WeakElementBonus.png": "e103",
	"./merge/Buff-Wind.png": "02aa",
	"./merge/Buff.png": "125a",
	"./merge/Debuff-AbnormalDisable.png": "5d89",
	"./merge/Debuff-AbnormalProbabilityDown.png": "c2c5",
	"./merge/Debuff-AbnormalProbabilityUp.png": "a174",
	"./merge/Debuff-AbsorbAttack.png": "f905",
	"./merge/Debuff-Atk.png": "626a",
	"./merge/Debuff-AtkCard.png": "8eb9",
	"./merge/Debuff-Barrier.png": "50ce",
	"./merge/Debuff-Bearish.png": "3b57",
	"./merge/Debuff-ChainCoef.png": "3196",
	"./merge/Debuff-Clear.png": "e185",
	"./merge/Debuff-Confusion.png": "3168",
	"./merge/Debuff-CriticalDamage.png": "a34f",
	"./merge/Debuff-Def.png": "fe11",
	"./merge/Debuff-Earth.png": "ce0c",
	"./merge/Debuff-Fire.png": "7d69",
	"./merge/Debuff-Forbidden.png": "c18e",
	"./merge/Debuff-Hate.png": "ebcf",
	"./merge/Debuff-Heal.png": "401f",
	"./merge/Debuff-HealCard.png": "9e05",
	"./merge/Debuff-Isolation.png": "cffb",
	"./merge/Debuff-LoadFactorReduce.png": "49cb",
	"./merge/Debuff-Luck.png": "25d2",
	"./merge/Debuff-MDef.png": "fd23",
	"./merge/Debuff-Mgc.png": "f68d",
	"./merge/Debuff-MgcCard.png": "f36d",
	"./merge/Debuff-Moon.png": "6bc0",
	"./merge/Debuff-NextAtk.png": "27b1",
	"./merge/Debuff-NextLuck.png": "ac9d",
	"./merge/Debuff-NextMgc.png": "e506",
	"./merge/Debuff-Other.png": "bde9",
	"./merge/Debuff-OtherCard.png": "a6c0",
	"./merge/Debuff-Paralysis.png": "5470",
	"./merge/Debuff-Poison.png": "6fd5",
	"./merge/Debuff-Recast.png": "51eb",
	"./merge/Debuff-Regene.png": "506f",
	"./merge/Debuff-Silence.png": "1728",
	"./merge/Debuff-Sleep.png": "b22f",
	"./merge/Debuff-Spd.png": "74b0",
	"./merge/Debuff-Sun.png": "71b1",
	"./merge/Debuff-Unhappy.png": "7119",
	"./merge/Debuff-Water.png": "29d1",
	"./merge/Debuff-WeakElementBonus.png": "6da3",
	"./merge/Debuff-Wind.png": "9879",
	"./merge/Debuff.png": "ca4c",
	"./merge/Earth-AbnormalDisable.png": "0251",
	"./merge/Earth-AbnormalProbabilityDown.png": "c2fb",
	"./merge/Earth-AbnormalProbabilityUp.png": "0554",
	"./merge/Earth-AbsorbAttack.png": "ec6b",
	"./merge/Earth-Atk.png": "6a77",
	"./merge/Earth-AtkCard.png": "ea79",
	"./merge/Earth-Barrier.png": "f6d1",
	"./merge/Earth-Bearish.png": "0983",
	"./merge/Earth-ChainCoef.png": "17e1",
	"./merge/Earth-Clear.png": "543f",
	"./merge/Earth-Confusion.png": "7c69",
	"./merge/Earth-CriticalDamage.png": "a54d",
	"./merge/Earth-Def.png": "0d2c",
	"./merge/Earth-Earth.png": "bb08",
	"./merge/Earth-Fire.png": "fe66",
	"./merge/Earth-Forbidden.png": "5695",
	"./merge/Earth-Hate.png": "50c0",
	"./merge/Earth-Heal.png": "2eb8",
	"./merge/Earth-HealCard.png": "fe4e",
	"./merge/Earth-Isolation.png": "f970",
	"./merge/Earth-LoadFactorReduce.png": "4b7e",
	"./merge/Earth-Luck.png": "1469",
	"./merge/Earth-MDef.png": "6f25",
	"./merge/Earth-Mgc.png": "126c",
	"./merge/Earth-MgcCard.png": "4817",
	"./merge/Earth-Moon.png": "d530",
	"./merge/Earth-NextAtk.png": "110f",
	"./merge/Earth-NextLuck.png": "b799",
	"./merge/Earth-NextMgc.png": "0b85",
	"./merge/Earth-Other.png": "760d",
	"./merge/Earth-OtherCard.png": "af9b",
	"./merge/Earth-Paralysis.png": "3397",
	"./merge/Earth-Poison.png": "f2c5",
	"./merge/Earth-Recast.png": "6d96",
	"./merge/Earth-Regene.png": "043e",
	"./merge/Earth-Silence.png": "a3e5",
	"./merge/Earth-Sleep.png": "6879",
	"./merge/Earth-Spd.png": "6d12",
	"./merge/Earth-Sun.png": "b9be",
	"./merge/Earth-Unhappy.png": "48f9",
	"./merge/Earth-Water.png": "723f",
	"./merge/Earth-WeakElementBonus.png": "0cc6",
	"./merge/Earth-Wind.png": "28dd",
	"./merge/Earth.png": "272a",
	"./merge/Fire-AbnormalDisable.png": "8b01",
	"./merge/Fire-AbnormalProbabilityDown.png": "fbcb",
	"./merge/Fire-AbnormalProbabilityUp.png": "dde6",
	"./merge/Fire-AbsorbAttack.png": "30b6",
	"./merge/Fire-Atk.png": "52b5",
	"./merge/Fire-AtkCard.png": "8bcc",
	"./merge/Fire-Barrier.png": "d890",
	"./merge/Fire-Bearish.png": "3820",
	"./merge/Fire-ChainCoef.png": "1db3",
	"./merge/Fire-Clear.png": "4bfd",
	"./merge/Fire-Confusion.png": "6c69",
	"./merge/Fire-CriticalDamage.png": "1355",
	"./merge/Fire-Def.png": "ab63",
	"./merge/Fire-Earth.png": "d19c",
	"./merge/Fire-Fire.png": "df32",
	"./merge/Fire-Forbidden.png": "2e8a",
	"./merge/Fire-Hate.png": "b7db",
	"./merge/Fire-Heal.png": "0b22",
	"./merge/Fire-HealCard.png": "a9a9",
	"./merge/Fire-Isolation.png": "5b6c",
	"./merge/Fire-LoadFactorReduce.png": "5a34",
	"./merge/Fire-Luck.png": "a963",
	"./merge/Fire-MDef.png": "7d47",
	"./merge/Fire-Mgc.png": "a254",
	"./merge/Fire-MgcCard.png": "9406",
	"./merge/Fire-Moon.png": "aa2d",
	"./merge/Fire-NextAtk.png": "b445",
	"./merge/Fire-NextLuck.png": "bf02",
	"./merge/Fire-NextMgc.png": "c300",
	"./merge/Fire-Other.png": "39f8",
	"./merge/Fire-OtherCard.png": "6f11",
	"./merge/Fire-Paralysis.png": "57e2",
	"./merge/Fire-Poison.png": "53cc",
	"./merge/Fire-Recast.png": "dedc",
	"./merge/Fire-Regene.png": "fe87",
	"./merge/Fire-Silence.png": "8192",
	"./merge/Fire-Sleep.png": "dee9",
	"./merge/Fire-Spd.png": "fb7f",
	"./merge/Fire-Sun.png": "eab6",
	"./merge/Fire-Unhappy.png": "f736",
	"./merge/Fire-Water.png": "78a1",
	"./merge/Fire-WeakElementBonus.png": "bb63",
	"./merge/Fire-Wind.png": "b1fe",
	"./merge/Fire.png": "72e3",
	"./merge/Heal-AbnormalDisable.png": "d579",
	"./merge/Heal-AbnormalProbabilityDown.png": "c9ed",
	"./merge/Heal-AbnormalProbabilityUp.png": "4eea",
	"./merge/Heal-AbsorbAttack.png": "9f5a",
	"./merge/Heal-Atk.png": "b155",
	"./merge/Heal-AtkCard.png": "badc",
	"./merge/Heal-Barrier.png": "d5c6",
	"./merge/Heal-Bearish.png": "2c97",
	"./merge/Heal-ChainCoef.png": "62f3",
	"./merge/Heal-Clear.png": "0361",
	"./merge/Heal-Confusion.png": "a52e",
	"./merge/Heal-CriticalDamage.png": "76a9",
	"./merge/Heal-Def.png": "3fbe",
	"./merge/Heal-Earth.png": "1680",
	"./merge/Heal-Fire.png": "b69c",
	"./merge/Heal-Forbidden.png": "2174",
	"./merge/Heal-Hate.png": "d522",
	"./merge/Heal-Heal.png": "734a",
	"./merge/Heal-HealCard.png": "3549",
	"./merge/Heal-Isolation.png": "571f",
	"./merge/Heal-LoadFactorReduce.png": "38ca",
	"./merge/Heal-Luck.png": "27c9",
	"./merge/Heal-MDef.png": "2d39",
	"./merge/Heal-Mgc.png": "c780",
	"./merge/Heal-MgcCard.png": "4cba",
	"./merge/Heal-Moon.png": "4662",
	"./merge/Heal-NextAtk.png": "9da2",
	"./merge/Heal-NextLuck.png": "6cb7",
	"./merge/Heal-NextMgc.png": "535a",
	"./merge/Heal-Other.png": "5f1b8",
	"./merge/Heal-OtherCard.png": "8dd2",
	"./merge/Heal-Paralysis.png": "b042",
	"./merge/Heal-Poison.png": "3adf",
	"./merge/Heal-Recast.png": "b5e5",
	"./merge/Heal-Regene.png": "9276",
	"./merge/Heal-Silence.png": "fb04",
	"./merge/Heal-Sleep.png": "a16d",
	"./merge/Heal-Spd.png": "25b0",
	"./merge/Heal-Sun.png": "50ef",
	"./merge/Heal-Unhappy.png": "9a1c",
	"./merge/Heal-Water.png": "d667",
	"./merge/Heal-WeakElementBonus.png": "f292",
	"./merge/Heal-Wind.png": "8c30",
	"./merge/Heal.png": "54ae",
	"./merge/Moon-AbnormalDisable.png": "d2dd",
	"./merge/Moon-AbnormalProbabilityDown.png": "b8f4",
	"./merge/Moon-AbnormalProbabilityUp.png": "7344",
	"./merge/Moon-AbsorbAttack.png": "8e49",
	"./merge/Moon-Atk.png": "2457",
	"./merge/Moon-AtkCard.png": "8f71",
	"./merge/Moon-Barrier.png": "05bd",
	"./merge/Moon-Bearish.png": "90aa",
	"./merge/Moon-ChainCoef.png": "9662",
	"./merge/Moon-Clear.png": "d33e",
	"./merge/Moon-Confusion.png": "e96a",
	"./merge/Moon-CriticalDamage.png": "cca4",
	"./merge/Moon-Def.png": "4f8f",
	"./merge/Moon-Earth.png": "cb5d",
	"./merge/Moon-Fire.png": "b0bf",
	"./merge/Moon-Forbidden.png": "2185",
	"./merge/Moon-Hate.png": "d94b",
	"./merge/Moon-Heal.png": "1cc2",
	"./merge/Moon-HealCard.png": "842e",
	"./merge/Moon-Isolation.png": "2125",
	"./merge/Moon-LoadFactorReduce.png": "03f6",
	"./merge/Moon-Luck.png": "6fa4",
	"./merge/Moon-MDef.png": "545c",
	"./merge/Moon-Mgc.png": "4b30",
	"./merge/Moon-MgcCard.png": "4d41",
	"./merge/Moon-Moon.png": "827f",
	"./merge/Moon-NextAtk.png": "4f1b",
	"./merge/Moon-NextLuck.png": "7af2",
	"./merge/Moon-NextMgc.png": "eaaf",
	"./merge/Moon-Other.png": "ecf7",
	"./merge/Moon-OtherCard.png": "e629",
	"./merge/Moon-Paralysis.png": "5d7c",
	"./merge/Moon-Poison.png": "ffd3",
	"./merge/Moon-Recast.png": "13ff",
	"./merge/Moon-Regene.png": "562c",
	"./merge/Moon-Silence.png": "fe8e",
	"./merge/Moon-Sleep.png": "d1f4",
	"./merge/Moon-Spd.png": "b948",
	"./merge/Moon-Sun.png": "d5c1",
	"./merge/Moon-Unhappy.png": "2d78",
	"./merge/Moon-Water.png": "fcdd",
	"./merge/Moon-WeakElementBonus.png": "ffca",
	"./merge/Moon-Wind.png": "8037",
	"./merge/Moon.png": "e4e9",
	"./merge/Other-AbnormalDisable.png": "86dd",
	"./merge/Other-AbnormalProbabilityDown.png": "7071",
	"./merge/Other-AbnormalProbabilityUp.png": "4cbf",
	"./merge/Other-AbsorbAttack.png": "be54",
	"./merge/Other-Atk.png": "2de1",
	"./merge/Other-AtkCard.png": "301e",
	"./merge/Other-Barrier.png": "5b9d",
	"./merge/Other-Bearish.png": "0363",
	"./merge/Other-ChainCoef.png": "0d0b",
	"./merge/Other-Clear.png": "1624",
	"./merge/Other-Confusion.png": "b034",
	"./merge/Other-CriticalDamage.png": "dad1",
	"./merge/Other-Def.png": "546a",
	"./merge/Other-Earth.png": "bd09",
	"./merge/Other-Fire.png": "44e2",
	"./merge/Other-Forbidden.png": "c405",
	"./merge/Other-Hate.png": "ae52",
	"./merge/Other-Heal.png": "6c61",
	"./merge/Other-HealCard.png": "23ed",
	"./merge/Other-Isolation.png": "3312",
	"./merge/Other-LoadFactorReduce.png": "5272",
	"./merge/Other-Luck.png": "192d",
	"./merge/Other-MDef.png": "6174",
	"./merge/Other-Mgc.png": "d23b",
	"./merge/Other-MgcCard.png": "1eb0",
	"./merge/Other-Moon.png": "9c18",
	"./merge/Other-NextAtk.png": "5f34",
	"./merge/Other-NextLuck.png": "bc93",
	"./merge/Other-NextMgc.png": "e25f",
	"./merge/Other-Other.png": "800a",
	"./merge/Other-OtherCard.png": "e242",
	"./merge/Other-Paralysis.png": "c565",
	"./merge/Other-Poison.png": "0b36",
	"./merge/Other-Recast.png": "b643",
	"./merge/Other-Regene.png": "95eb",
	"./merge/Other-Silence.png": "c15d",
	"./merge/Other-Sleep.png": "1025",
	"./merge/Other-Spd.png": "3f9c",
	"./merge/Other-Sun.png": "f01f",
	"./merge/Other-Unhappy.png": "1661",
	"./merge/Other-Water.png": "dc9f",
	"./merge/Other-WeakElementBonus.png": "e3da",
	"./merge/Other-Wind.png": "9a92",
	"./merge/Other.png": "eff5",
	"./merge/Other2-AbnormalDisable.png": "8692",
	"./merge/Other2-AbnormalProbabilityDown.png": "03f5",
	"./merge/Other2-AbnormalProbabilityUp.png": "d730",
	"./merge/Other2-AbsorbAttack.png": "e536",
	"./merge/Other2-Atk.png": "3115",
	"./merge/Other2-AtkCard.png": "b67b",
	"./merge/Other2-Barrier.png": "de40",
	"./merge/Other2-Bearish.png": "4441",
	"./merge/Other2-ChainCoef.png": "acf5",
	"./merge/Other2-Clear.png": "4dd4",
	"./merge/Other2-Confusion.png": "de22",
	"./merge/Other2-CriticalDamage.png": "a7bf",
	"./merge/Other2-Def.png": "13a0",
	"./merge/Other2-Earth.png": "45ff",
	"./merge/Other2-Fire.png": "4289",
	"./merge/Other2-Forbidden.png": "1f6f",
	"./merge/Other2-Hate.png": "054a",
	"./merge/Other2-Heal.png": "ea5f",
	"./merge/Other2-HealCard.png": "4039",
	"./merge/Other2-Isolation.png": "c2d9",
	"./merge/Other2-LoadFactorReduce.png": "1b05",
	"./merge/Other2-Luck.png": "7fc6",
	"./merge/Other2-MDef.png": "a07b",
	"./merge/Other2-Mgc.png": "4881",
	"./merge/Other2-MgcCard.png": "15df",
	"./merge/Other2-Moon.png": "fb88",
	"./merge/Other2-NextAtk.png": "ff8d9",
	"./merge/Other2-NextLuck.png": "c3d5",
	"./merge/Other2-NextMgc.png": "3f7a",
	"./merge/Other2-Other.png": "87cd",
	"./merge/Other2-OtherCard.png": "d53bb",
	"./merge/Other2-Paralysis.png": "e842",
	"./merge/Other2-Poison.png": "9072",
	"./merge/Other2-Recast.png": "5361",
	"./merge/Other2-Regene.png": "580c",
	"./merge/Other2-Silence.png": "4178",
	"./merge/Other2-Sleep.png": "8305",
	"./merge/Other2-Spd.png": "c35c",
	"./merge/Other2-Sun.png": "83a4",
	"./merge/Other2-Unhappy.png": "d030",
	"./merge/Other2-Water.png": "e862",
	"./merge/Other2-WeakElementBonus.png": "591d",
	"./merge/Other2-Wind.png": "5631",
	"./merge/Other2.png": "4a55",
	"./merge/Sun-AbnormalDisable.png": "6c2a",
	"./merge/Sun-AbnormalProbabilityDown.png": "2f07",
	"./merge/Sun-AbnormalProbabilityUp.png": "1af6",
	"./merge/Sun-AbsorbAttack.png": "5dfd",
	"./merge/Sun-Atk.png": "13c5",
	"./merge/Sun-AtkCard.png": "6d70",
	"./merge/Sun-Barrier.png": "a751",
	"./merge/Sun-Bearish.png": "d293",
	"./merge/Sun-ChainCoef.png": "5b03",
	"./merge/Sun-Clear.png": "9bfd",
	"./merge/Sun-Confusion.png": "0444",
	"./merge/Sun-CriticalDamage.png": "cc71",
	"./merge/Sun-Def.png": "2770",
	"./merge/Sun-Earth.png": "7d52",
	"./merge/Sun-Fire.png": "e617",
	"./merge/Sun-Forbidden.png": "83c5",
	"./merge/Sun-Hate.png": "b6e9",
	"./merge/Sun-Heal.png": "0d22",
	"./merge/Sun-HealCard.png": "d8e5",
	"./merge/Sun-Isolation.png": "3594",
	"./merge/Sun-LoadFactorReduce.png": "fadb",
	"./merge/Sun-Luck.png": "4b03",
	"./merge/Sun-MDef.png": "e109",
	"./merge/Sun-Mgc.png": "c97e",
	"./merge/Sun-MgcCard.png": "6ffa",
	"./merge/Sun-Moon.png": "6c2d",
	"./merge/Sun-NextAtk.png": "7a69",
	"./merge/Sun-NextLuck.png": "d0af",
	"./merge/Sun-NextMgc.png": "0469",
	"./merge/Sun-Other.png": "5803",
	"./merge/Sun-OtherCard.png": "3d67",
	"./merge/Sun-Paralysis.png": "74bd",
	"./merge/Sun-Poison.png": "6b38",
	"./merge/Sun-Recast.png": "2289",
	"./merge/Sun-Regene.png": "1516",
	"./merge/Sun-Silence.png": "56e7",
	"./merge/Sun-Sleep.png": "75ed",
	"./merge/Sun-Spd.png": "4c17",
	"./merge/Sun-Sun.png": "529d",
	"./merge/Sun-Unhappy.png": "b554",
	"./merge/Sun-Water.png": "e311",
	"./merge/Sun-WeakElementBonus.png": "8f17",
	"./merge/Sun-Wind.png": "e2c3",
	"./merge/Sun.png": "fe68",
	"./merge/Water-AbnormalDisable.png": "cc8f",
	"./merge/Water-AbnormalProbabilityDown.png": "4644",
	"./merge/Water-AbnormalProbabilityUp.png": "bdab",
	"./merge/Water-AbsorbAttack.png": "9e8d",
	"./merge/Water-Atk.png": "19a7",
	"./merge/Water-AtkCard.png": "0414",
	"./merge/Water-Barrier.png": "08c2",
	"./merge/Water-Bearish.png": "7af4",
	"./merge/Water-ChainCoef.png": "cb0f",
	"./merge/Water-Clear.png": "483d",
	"./merge/Water-Confusion.png": "19fd",
	"./merge/Water-CriticalDamage.png": "7ce8",
	"./merge/Water-Def.png": "5468",
	"./merge/Water-Earth.png": "ee3c",
	"./merge/Water-Fire.png": "9dce",
	"./merge/Water-Forbidden.png": "65a5",
	"./merge/Water-Hate.png": "7b9e",
	"./merge/Water-Heal.png": "2f62",
	"./merge/Water-HealCard.png": "fbc1",
	"./merge/Water-Isolation.png": "12f5",
	"./merge/Water-LoadFactorReduce.png": "e597",
	"./merge/Water-Luck.png": "5136",
	"./merge/Water-MDef.png": "c37e",
	"./merge/Water-Mgc.png": "51f2",
	"./merge/Water-MgcCard.png": "1fc8",
	"./merge/Water-Moon.png": "ab31",
	"./merge/Water-NextAtk.png": "0a65",
	"./merge/Water-NextLuck.png": "ef5a",
	"./merge/Water-NextMgc.png": "ff34",
	"./merge/Water-Other.png": "bfdb",
	"./merge/Water-OtherCard.png": "10fd",
	"./merge/Water-Paralysis.png": "7080",
	"./merge/Water-Poison.png": "4f11",
	"./merge/Water-Recast.png": "3f48",
	"./merge/Water-Regene.png": "0157",
	"./merge/Water-Silence.png": "849c",
	"./merge/Water-Sleep.png": "799f",
	"./merge/Water-Spd.png": "1982",
	"./merge/Water-Sun.png": "84ce",
	"./merge/Water-Unhappy.png": "53ef",
	"./merge/Water-Water.png": "37cf",
	"./merge/Water-WeakElementBonus.png": "2513",
	"./merge/Water-Wind.png": "32e1",
	"./merge/Water.png": "6cfd",
	"./merge/Wind-AbnormalDisable.png": "f8360",
	"./merge/Wind-AbnormalProbabilityDown.png": "998d",
	"./merge/Wind-AbnormalProbabilityUp.png": "270f",
	"./merge/Wind-AbsorbAttack.png": "7086",
	"./merge/Wind-Atk.png": "352b",
	"./merge/Wind-AtkCard.png": "69d7",
	"./merge/Wind-Barrier.png": "4a91",
	"./merge/Wind-Bearish.png": "2c10",
	"./merge/Wind-ChainCoef.png": "3107",
	"./merge/Wind-Clear.png": "41f6",
	"./merge/Wind-Confusion.png": "0ca5",
	"./merge/Wind-CriticalDamage.png": "1411",
	"./merge/Wind-Def.png": "128f",
	"./merge/Wind-Earth.png": "54e2",
	"./merge/Wind-Fire.png": "a60d",
	"./merge/Wind-Forbidden.png": "dd14",
	"./merge/Wind-Hate.png": "6bf8",
	"./merge/Wind-Heal.png": "bf2f",
	"./merge/Wind-HealCard.png": "08f2",
	"./merge/Wind-Isolation.png": "67fe",
	"./merge/Wind-LoadFactorReduce.png": "60e1",
	"./merge/Wind-Luck.png": "6883",
	"./merge/Wind-MDef.png": "1cfa",
	"./merge/Wind-Mgc.png": "0391",
	"./merge/Wind-MgcCard.png": "f2ab",
	"./merge/Wind-Moon.png": "2927",
	"./merge/Wind-NextAtk.png": "16b8",
	"./merge/Wind-NextLuck.png": "bb7c",
	"./merge/Wind-NextMgc.png": "395f",
	"./merge/Wind-Other.png": "06a0",
	"./merge/Wind-OtherCard.png": "7d26",
	"./merge/Wind-Paralysis.png": "671e",
	"./merge/Wind-Poison.png": "6ad9",
	"./merge/Wind-Recast.png": "d5e8",
	"./merge/Wind-Regene.png": "ee26",
	"./merge/Wind-Silence.png": "4f74",
	"./merge/Wind-Sleep.png": "d811",
	"./merge/Wind-Spd.png": "e0e3",
	"./merge/Wind-Sun.png": "c5e2",
	"./merge/Wind-Unhappy.png": "9a8b",
	"./merge/Wind-Water.png": "a2a4",
	"./merge/Wind-WeakElementBonus.png": "dcf4",
	"./merge/Wind-Wind.png": "a46c",
	"./merge/Wind.png": "271f",
	"./zh/0.md": "51e4",
	"./zh/1.md": "cff7",
	"./zh/10.md": "898b",
	"./zh/11.md": "9ac4",
	"./zh/12.md": "4965",
	"./zh/13.md": "644a1",
	"./zh/14.md": "7f55",
	"./zh/15.md": "2034",
	"./zh/16.md": "4492",
	"./zh/17.md": "54d6",
	"./zh/18.md": "a25c",
	"./zh/19.md": "9478",
	"./zh/2.md": "05a4",
	"./zh/20.md": "f86e",
	"./zh/21.md": "9f16",
	"./zh/22.md": "a5b5",
	"./zh/23.md": "0630",
	"./zh/24.md": "ec27",
	"./zh/25.md": "1d68",
	"./zh/26.md": "2205",
	"./zh/3.md": "e6a7",
	"./zh/4.md": "0a29",
	"./zh/5.md": "a0a2",
	"./zh/6.md": "bc0d",
	"./zh/7.md": "e8fd",
	"./zh/8.md": "acc0",
	"./zh/9.md": "1d60",
	"./zh/appendix0.md": "793a",
	"./zh/appendix1.md": "391d",
	"./zh/appendix2.md": "3fa2",
	"./zh/appendix3.md": "08a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "609c";